export default __webpack_public_path__ + "static/media/frontBlog.779f9240.jpg";